import { Button, Grid, Stack, Table } from "@mui/joy";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { server_url } from "../core/config_geral";
import axios from "axios";

function MediasDashboard() {

    const token = useSelector((state) => state.auth.token);

    const [state, setState] = useState({
        loading: true,
        error: null,
        medias: []
    })

    const atualizaDados = async () => {
        setState(prev => ({
            ...prev,
            loading: true,
            error: null,
            medias: []
        }));
        var formData = new FormData()
        var formToSend = {
            action: "CASTOR_RETORNA_MEDIAS_CASTOR_RPC",
            runNow: true,
            payload: ""
        }

        formData.append("file", null)
        formData.append("data",
            new Blob([JSON.stringify(formToSend)], {
                type: "application/json"
            }))


        var r = await axios.post(server_url + "/rpc", formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + token
            }
        }).then(response => response)
            .catch(error => error)

        if (r.status == 200) {
            setState(prev => ({
                ...prev,
                loading: false,
                error: null,
                medias: r.data.payload
            }));
        } else {
            setState(prev => ({
                ...prev,
                loading: false,
                error: "Não foi possível pegar todas as medias (Vide console)",
                medias: []
            }));
            console.log("error", r);
        }
    }

    React.useEffect(() => {
        atualizaDados();
    }, []);

    if (state.loading)
        return <Grid xs={12}>
            Loading...
        </Grid>

    return <>
        <Grid xs={12}>
            <Stack direction={"row"} spacing={1}>
                <Link to="/medias/adicionar">
                    <Button color="primary">Nova media</Button>
                </Link>
                <Link onClick={atualizaDados}>
                    <Button color="danger">Atualizar</Button>
                </Link>
            </Stack>
        </Grid>
        <Grid xs={12}>
            <Table size="sm" stripe={"odd"} >
                <thead>
                    <tr>
                        <td>Data</td>
                        <td>Descrição</td>
                        <td>Tipo</td>
                        <td>Download</td>
                    </tr>
                </thead>
                <tbody>
                    {state.medias.map((m, index) => <tr key={index}>
                        <td>{m.createdAtFormatted}</td>
                        <td>{m.descricao}</td>
                        <td>{m.tipo}</td>
                        <td>
                            <Link>
                                Download
                            </Link>
                        </td>
                    </tr>)}
                </tbody>
            </Table>
        </Grid>
    </>
}

export default MediasDashboard